<div class="tab-content">
  <ng-content></ng-content>
</div>